export const createFuseOptions = (keys, fuseOptions = {}) => {
  return {
    fuseOptions: {
      keys,
      threshold: 0.3,
      ignoreLocation: true,
      ...fuseOptions,
    },
  }
}
